import { Controller } from "@hotwired/stimulus"
import { forceSetValueOnSelect, trySetValue, setValueAndDispatch } from "../helpers"
import { taxNoKindPlaceholder } from "../helpers/tax_no"

export default class extends Controller {
  static targets = ["destroy", "taxNoElem", "taxNoKind", "taxNo", "addressMore", "buttonLess", "buttonMore", "participation", "roleDescription"]
  static values = {
    index: { type: Number, default: 0 },
    kind: String,
    constAdditionalBuyer: String,
    constRoleOther: String,
    jstRole: String,
    gvRole: String,
  }

  static outlets = ["invoice", "invoice--jst-gv"]

  connect() {
    if (this.hasTaxNoKindTarget && this.hasTaxNoTarget) this.kindChanged()
  }

  kindChanged() {
    taxNoKindPlaceholder(this.taxNoKindTarget, this.taxNoTarget)
  }

  switchType(event) {
    if (event.currentTarget.value === "true") {
      this.element.querySelector(`[data-contractor-person="${this.indexValue}"]`).classList.add("hidden")
      const recicpientCompanyElems = this.element.querySelectorAll(`[data-contractor-company="${this.indexValue}"]`)
      recicpientCompanyElems.forEach((element) => element.classList.remove("hidden"))
      recicpientCompanyElems[recicpientCompanyElems.length - 1].after(this.taxNoElemTarget)
      if (this.invoiceOutlet.localeValue === "fr") {
        this.taxNoElemTarget.classList.remove("hidden")
      }
    } else {
      this.element.querySelectorAll(`[data-contractor-company="${this.indexValue}"]`).forEach((element) => element.classList.add("hidden"))
      this.element.querySelector(`[data-contractor-person="${this.indexValue}"]`).classList.remove("hidden")
      this.addressMoreTarget.append(this.taxNoElemTarget)

      if (this.invoiceOutlet.localeValue === "fr") {
        this.taxNoElemTarget.classList.add("hidden")
      }

      if (this.invoiceOutlet.localeValue === "pl" && this.invoiceOutlet.newRecordValue) {
        const taxKindElem = this.element.querySelector("[data-invoice--tax-target=\"kind\"]")
        if (taxKindElem && taxKindElem.querySelector("option[value='empty']")) {
          setValueAndDispatch(taxKindElem, "empty")
        }
      }
    }
  }

  toggleAdditional() { // uzywane w mobilu, po uspojnieniu tw i tw_mobile do usuniecia
    this.addressMoreTargets.forEach((target) => target.classList.toggle("hidden"))
    if (this.buttonLessTarget.classList.contains("hidden")) {
      this.buttonMoreTarget.classList.add("hidden")
      this.buttonLessTarget.classList.remove("hidden")
    } else {
      this.buttonLessTarget.classList.add("hidden")
      this.buttonMoreTarget.classList.remove("hidden")
    }
  }

  delete(event) {
    const confirmed = confirm(event.currentTarget.getAttribute("data-confirm"))
    if (confirmed) {
      this.element.classList.add("hidden")
      this.destroyTarget.checked = true
    }
  }

  showParticipation(event) {
    if (!this.hasParticipationTarget) return

    if (event.currentTarget.value === this.constAdditionalBuyerValue) { // tylko wtedy pokazujemy pole na udział
      this.participationTarget.classList.remove("hidden")
    } else {
      this.participationTarget.classList.add("hidden")
    }
  }

  showRoleDescription(event) {
    if (!this.hasRoleDescriptionTarget) return

    if (event.currentTarget.value === this.constRoleOtherValue) { // tylko wtedy pokazujemy pole na udział
      this.roleDescriptionTarget.classList.remove("hidden")
    } else {
      this.roleDescriptionTarget.classList.add("hidden")
    }
  }

  // rola odbiorcy → checkbox JST/GV: tylko zaznaczamy, nigdy nie odznaczamy (jawny wybór usera na formularzu jest nadrzędny)
  syncJstGv(event) {
    if (this.kindValue !== "recipient" || !this.hasInvoiceJstGvOutlet) return

    if (event.currentTarget.value === this.jstRoleValue) {
      this.invoiceJstGvOutlet.checkJst()
    } else if (event.currentTarget.value === this.gvRoleValue) {
      this.invoiceJstGvOutlet.checkGv()
    }
  }

  fillContractor(contractor) {
    const prefix = `invoice_${this.kindValue}s_attributes_${this.indexValue}`
    trySetValue(`#${prefix}_tax_no`, contractor.tax_no)
    trySetValue(`#${prefix}_post_code`, contractor.post_code)
    trySetValue(`#${prefix}_city`, contractor.city)
    trySetValue(`#${prefix}_street`, contractor.street)
    forceSetValueOnSelect(document.querySelector(`#${prefix}_country`), contractor.country)
    trySetValue(`#${prefix}_email`, contractor.email)
    trySetValue(`#${prefix}_phone`, contractor.phone)
    trySetValue(`#${prefix}_name`, contractor.name)
    trySetValue(`#${prefix}_first_name`, contractor.first_name)
    trySetValue(`#${prefix}_last_name`, contractor.last_name)

    if (contractor.note) {
      trySetValue(`#${prefix}_note`, contractor.note)
    }

    if (this.invoiceOutlet.ksefEnabledValue) {
      trySetValue(`#${prefix}_role`, contractor.role)
      trySetValue(`#${prefix}_participation`, contractor.participation || "")
      document.getElementById(`${prefix}_role`).dispatchEvent(new Event("change"))
    }
  }
}
